<template>
  <a-tabs default-active-key="1">
    <a-tab-pane key="1" tab="合计">
      <blend-material :rowId="rowId" :url="totalUrl" :columns="totalColumns" :valKeys='totalKeys' :len='2'/>
    </a-tab-pane>
    <a-tab-pane key="2" tab="补充料">
      <blend-material :rowId="rowId" :url="supplementUrl" :columns="nutritionSupplementColumns" :valKeys='nutritionSupplement' :len='2'/>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import BlendMaterial from "./BlendMaterial2";
import {totalColumns,nutritionSupplementColumns} from './blendConfig'
let totalKeys = []
let nutritionSupplement = []
totalColumns.forEach(el => {
  if(el.scopedSlots) totalKeys.push(el.dataIndex)
})
nutritionSupplementColumns.forEach(el => {
  if(el.scopedSlots) nutritionSupplement.push(el.dataIndex)
})
export default {
  components: {BlendMaterial},
  props: ['rowId'],
  data(){
    return {
      totalColumns,nutritionSupplementColumns,
      totalUrl: '/nhf-app/archivedFormula/formulaMixNutritionList',
      supplementUrl: '/nhf-app/archivedFormula/formulaNutritionList',
      nutritionSupplement,totalKeys
    }
  }
}
</script>
